/* Adventure sections — reveal animations and background parallax.
   Loaded with "defer". If it never runs, each section's inline fallback
   removes the hidden state after 2.5s, so content can never stay invisible. */
(function () {
  if (window.__advInit) return;
  window.__advInit = true;
  var root = document.documentElement;
  root.classList.add('adv-js');
  /* translations from <script type="application/json" data-rr-i18n> (layout/theme.liquid); English stays the fallback */
  var RRI = {};
  try { Array.prototype.forEach.call(document.querySelectorAll('script[data-rr-i18n]'), function (s) { try { var o = JSON.parse(s.textContent); for (var k in o) RRI[k] = o[k]; } catch (e) {} }); } catch (e) {}
  function rrT(k, d) { var v = RRI[k]; return typeof v === 'string' && v !== '' ? v.replace(/"/g, '&quot;').replace(/</g, '&lt;') : d; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target, repeat = el.hasAttribute('data-anim-repeat');
        if (e.isIntersecting) {
          el.classList.add('is-in');
          if (!repeat) io.unobserve(el);
        } else if (repeat) {
          el.classList.remove('is-in');
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  }

  function scan(scope) {
    var vh = window.innerHeight;
    (scope || document).querySelectorAll('.adv [data-anim], .adv [data-side-in]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      var visible = r.top < vh && r.bottom > 0;
      if (!io || visible) el.classList.add('is-in');
      if (io && (!visible || el.hasAttribute('data-anim-repeat'))) io.observe(el);
    });
    setupParallax(scope || document);
    setupSides(scope || document);
  }

  /* ---------- side images: follow the mouse (desktop) ---------- */
  var boxes = [], mx = 0, my = 0, sideTick = false;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function setupSides(scope) {
    if (reduce || !finePointer) return;
    scope.querySelectorAll('.adv-sidebox').forEach(function (box) {
      if (box.__adv) return;
      var on = false;
      box.querySelectorAll('.adv-side').forEach(function (s) { if (parseFloat(getComputedStyle(s).getPropertyValue('--spd')) > 0) on = true; });
      if (!on) return;
      box.__adv = true;
      boxes.push(box);
    });
  }
  function moveSides() {
    sideTick = false;
    var vh = window.innerHeight;
    boxes = boxes.filter(function (b) { return b.isConnected; });
    boxes.forEach(function (box) {
      var r = box.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var x = Math.max(-1, Math.min(1, (mx - (r.left + r.width / 2)) / (r.width / 2)));
      var y = Math.max(-1, Math.min(1, (my - (r.top + r.height / 2)) / Math.max(r.height, vh / 2)));
      box.style.setProperty('--mx', x.toFixed(3));
      box.style.setProperty('--my', y.toFixed(3));
    });
  }
  document.addEventListener('mousemove', function (e) {
    if (!boxes.length) return;
    mx = e.clientX; my = e.clientY;
    if (!sideTick) { sideTick = true; requestAnimationFrame(moveSides); }
  }, { passive: true });
  document.addEventListener('mouseleave', function () {
    boxes.forEach(function (box) { box.style.setProperty('--mx', 0); box.style.setProperty('--my', 0); });
  });

  /* ---------- parallax ---------- */
  var layers = [];
  var ticking = false;
  function setupParallax(scope) {
    scope.querySelectorAll('.adv-bg--parallax').forEach(function (bg) {
      if (bg.__adv) return;
      bg.__adv = true;
      layers.push(bg);
    });
    update();
  }
  function update() {
    ticking = false;
    if (reduce) return;
    var vh = window.innerHeight;
    layers.forEach(function (bg) {
      var sec = bg.parentElement;
      if (!sec || !bg.isConnected) return;
      var r = sec.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var speed = parseFloat(bg.getAttribute('data-speed') || '0.3');
      var progress = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
      var pic = bg.firstElementChild;
      if (pic) pic.style.transform = 'translate3d(0,' + (progress * speed * -100).toFixed(2) + '%,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking && layers.length) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);

  /* ---------- FAQ: smooth open / close ---------- */
  function animateDetails(d, open) {
    var box = d.querySelector('.a');
    var wrap = d.closest('.adv-faq');
    var dur = reduce ? 0 : parseInt((wrap && wrap.getAttribute('data-speed')) || '350', 10);
    if (!box || !box.animate || dur === 0) { d.open = open; return; }
    if (d.__advAnim) d.__advAnim.cancel();
    if (open) {
      d.open = true;
      var h = box.scrollHeight;
      d.__advAnim = box.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: dur, easing: 'cubic-bezier(.4,0,.2,1)' });
    } else {
      d.classList.add('is-closing');
      var h2 = box.scrollHeight;
      d.__advAnim = box.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: dur, easing: 'cubic-bezier(.4,0,.2,1)' });
      d.__advAnim.onfinish = function () { d.open = false; d.classList.remove('is-closing'); };
    }
    d.__advAnim.oncancel = function () { d.classList.remove('is-closing'); };
  }
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('.adv-faq summary');
    if (!sum) return;
    var d = sum.parentElement;
    e.preventDefault();
    var opening = !d.open || d.classList.contains('is-closing');
    if (opening) {
      var wrap = d.closest('.adv-faq');
      if (wrap && wrap.hasAttribute('data-one-open')) {
        wrap.querySelectorAll('details[open]').forEach(function (o) { if (o !== d && !o.classList.contains('is-closing')) animateDetails(o, false); });
      }
      d.classList.remove('is-closing');
    }
    animateDetails(d, opening);
  });

  /* ---------- gallery: carousel arrows + lightbox ---------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[data-adv-scroll]');
    if (arrow) {
      var track = arrow.closest('.adv-gal').querySelector('.adv-gal__track');
      var step = track.clientWidth * 0.85 * (arrow.getAttribute('data-adv-scroll') === 'prev' ? -1 : 1);
      track.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    var zoom = e.target.closest && e.target.closest('[data-adv-zoom]');
    if (zoom) {
      if (e.advCf) return; // coverflow: a click on a side item only moves the carousel
      e.preventDefault();
      openLightbox(zoom);
    }
  });

  /* ---------- lightbox: loader (never shows the previous image), prev/next, caption ---------- */
  var lb, lbList = [], lbIdx = 0, lbToken = 0;
  function lbShow(i) {
    if (!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    var a = lbList[lbIdx], url = a.getAttribute('href'), img = lb.querySelector('img'), cap = lb.querySelector('.adv-lb__cap');
    var token = ++lbToken;
    lb.classList.add('is-loading');
    img.removeAttribute('src'); img.alt = a.getAttribute('data-alt') || '';
    cap.textContent = a.getAttribute('data-alt') || '';
    lb.querySelector('.adv-lb__count').textContent = lbList.length > 1 ? (lbIdx + 1) + ' / ' + lbList.length : '';
    var pre = new Image();
    pre.onload = pre.onerror = function () { if (token !== lbToken) return; img.src = url; lb.classList.remove('is-loading'); };
    pre.src = url;
    [lbIdx + 1, lbIdx - 1].forEach(function (j) { var n = lbList[(j + lbList.length) % lbList.length]; if (n) { var p = new Image(); p.src = n.getAttribute('href'); } });
  }
  /* page stays still while the lightbox is open (iOS-safe: body pinned at the current scroll) */
  var lbY = 0, lbLocked = false, lbOpener = null, lbAnchorT = 0;
  function lbLock() {
    if (lbLocked) return; lbLocked = true; lbY = window.scrollY || window.pageYOffset || 0;
    var sb = window.innerWidth - root.clientWidth, bs = document.body.style;
    lbOpener = document.activeElement; if (lbOpener && lbOpener.blur) lbOpener.blur();
    root.classList.add('adv-lb-open');
    clearTimeout(lbAnchorT); root.style.overflowAnchor = 'none';
    bs.position = 'fixed'; bs.top = -lbY + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%';
    if (sb > 0) bs.paddingRight = sb + 'px';
  }
  function lbUnlock() {
    if (!lbLocked) return; lbLocked = false;
    var bs = document.body.style;
    bs.position = bs.top = bs.left = bs.right = bs.width = bs.paddingRight = '';
    root.classList.remove('adv-lb-open');
    var prev = root.style.scrollBehavior; root.style.scrollBehavior = 'auto';
    window.scrollTo(0, lbY); root.style.scrollBehavior = prev;
    clearTimeout(lbAnchorT); lbAnchorT = setTimeout(function () { root.style.overflowAnchor = ''; }, 1200);
  }
  function openLightbox(zoom) {
    if (!lb) {
      lb = document.createElement('dialog');
      lb.id = 'adv-lightbox'; lb.className = 'adv-lb';
      lb.innerHTML = '<div class="adv-lb__box"><img alt=""><span class="adv-lb__spin" aria-hidden="true"></span></div>' +
        '<p class="adv-lb__bar"><span class="adv-lb__cap"></span><span class="adv-lb__count"></span></p>' +
        '<button type="button" class="adv-lb__close" aria-label="' + rrT('close', 'Close') + '">&times;</button>' +
        '<button type="button" class="adv-lb__nav adv-lb__nav--prev" aria-label="' + rrT('previous', 'Previous') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="adv-lb__nav adv-lb__nav--next" aria-label="' + rrT('next', 'Next') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>';
      document.body.appendChild(lb);
      lb.addEventListener('close', function () { lbUnlock(); if (lbOpener && lbOpener.focus) { try { lbOpener.focus({ preventScroll: true }); } catch (e) {} } lbOpener = null; });
      lb.addEventListener('cancel', lbUnlock);
      lb.addEventListener('wheel', function (ev) { ev.preventDefault(); }, { passive: false });
      lb.addEventListener('click', function (ev) {
        if (ev.target.closest('.adv-lb__nav--prev')) return lbShow(lbIdx - 1);
        if (ev.target.closest('.adv-lb__nav--next')) return lbShow(lbIdx + 1);
        if (ev.target === lb || ev.target.closest('.adv-lb__close')) { lbUnlock(); lb.close(); }
      });
      lb.addEventListener('keydown', function (ev) { if (ev.key === 'ArrowLeft') lbShow(lbIdx - 1); if (ev.key === 'ArrowRight') lbShow(lbIdx + 1); });
      var sx = null;
      lb.addEventListener('touchstart', function (ev) { sx = ev.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (ev) { if (sx === null) return; var dx = ev.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) lbShow(lbIdx + (dx < 0 ? 1 : -1)); sx = null; });
    }
    var group = zoom.closest('[data-adv-zoom-group]') || zoom.closest('.adv') || document;
    lbList = Array.prototype.slice.call(group.querySelectorAll('[data-adv-zoom]'));
    lb.classList.toggle('is-single', lbList.length < 2);
    if (lb.showModal) { if (!lb.open) { lbLock(); lb.showModal(); } lbShow(lbList.indexOf(zoom)); }
    else window.open(zoom.getAttribute('href'), '_blank');
  }

  /* ---------- coverflow: 3D carousel (gallery "coverflow" layout, adventure tour) ---------- */
  function initCoverflow(cf) {
    if (cf.__cf) return; cf.__cf = true;
    var stage = cf.querySelector('.adv-cf__stage');
    var items = Array.prototype.filter.call(stage.children, function (el) { return !el.classList.contains('adv-cf__sizer'); });
    var n = items.length; if (!n) return;
    var far = parseInt(cf.getAttribute('data-far') || '3', 10), dots = cf.querySelector('.adv-cf__dots'), active = Math.min(n - 1, parseInt(cf.getAttribute('data-start') || '0', 10) || 0);
    if (dots) { dots.innerHTML = ''; items.forEach(function (_, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', rrT('go_to', 'Go to ') + (i + 1)); b.addEventListener('click', function () { go(i); }); dots.appendChild(b); }); }
    function render() {
      items.forEach(function (el, i) {
        var o = i - active;
        if (n > 2) { if (o > n / 2) o -= n; if (o < -n / 2) o += n; }
        var a = Math.abs(o);
        el.style.setProperty('--o', o); el.style.setProperty('--a', a);
        el.style.zIndex = 50 - a;
        el.classList.toggle('is-active', o === 0);
        el.classList.toggle('is-far', a > far);
        el.setAttribute('aria-hidden', o === 0 ? 'false' : 'true');
      });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === active); });
    }
    function go(i) { active = (i + n) % n; render(); }
    cf.__go = function (d) { go(active + d); };
    items.forEach(function (el, i) { el.addEventListener('click', function (ev) { if (i !== active) { ev.preventDefault(); ev.advCf = true; go(i); } }); });
    cf.querySelectorAll('[data-cf]').forEach(function (b) { b.addEventListener('click', function () { go(active + (b.getAttribute('data-cf') === 'prev' ? -1 : 1)); }); });
    cf.addEventListener('keydown', function (ev) { if (ev.key === 'ArrowLeft') go(active - 1); if (ev.key === 'ArrowRight') go(active + 1); });
    var sx = null, sy = null;
    stage.addEventListener('pointerdown', function (ev) { sx = ev.clientX; sy = ev.clientY; });
    stage.addEventListener('pointerup', function (ev) { if (sx === null) return; var dx = ev.clientX - sx; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(ev.clientY - sy)) { go(active + (dx < 0 ? 1 : -1)); cf.__swiped = Date.now(); } sx = null; });
    stage.addEventListener('click', function (ev) { if (cf.__swiped && Date.now() - cf.__swiped < 350) { ev.preventDefault(); ev.stopPropagation(); } }, true);
    var every = parseFloat(cf.getAttribute('data-autoplay') || '0'), timer = null, hover = false;
    if (every > 0 && !reduce) {
      cf.addEventListener('mouseenter', function () { hover = true; }); cf.addEventListener('mouseleave', function () { hover = false; });
      timer = setInterval(function () { if (!hover && !document.hidden && cf.getBoundingClientRect().top < innerHeight && cf.getBoundingClientRect().bottom > 0) go(active + 1); }, every * 1000);
    }
    render();
  }
  function scanCf(root) { (root || document).querySelectorAll('[data-adv-cf]').forEach(initCoverflow); }

  /* ---------- catalog level filter ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-adv-filter] [data-lv]');
    if (!b || b.tagName !== 'BUTTON') return;
    var box = b.closest('[data-adv-filter]'), lv = b.getAttribute('data-lv').split(','), shown = 0;
    box.querySelectorAll('.adv-cg__filters button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    box.querySelectorAll('.adv-cg__card').forEach(function (c) {
      var on = lv[0] === 'all' || lv.indexOf(c.getAttribute('data-lv')) > -1;
      c.hidden = !on; if (on) { shown++; c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop'); }
    });
    var none = box.querySelector('.adv-cg__none'); if (none) none.hidden = shown > 0;
  });

  /* ---------- tabs (adventure tour) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-adv-tab]');
    if (!t) return;
    var box = t.closest('[data-adv-tabs]'), id = t.getAttribute('data-adv-tab');
    box.querySelectorAll('[data-adv-tab]').forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    box.querySelectorAll('[data-adv-panel]').forEach(function (p) { var on = p.getAttribute('data-adv-panel') === id; p.hidden = !on; if (on) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); scanCf(p); } });
  });

  /* ---------- carousels: load every slide shortly before the section scrolls into view ---------- */
  function warmImgs(el) { el.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }
  var warmIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { warmImgs(e.target); warmIO.unobserve(e.target); } });
  }, { rootMargin: '900px 0px 900px 0px' }) : null;
  function scanWarm(scope) {
    (scope || document).querySelectorAll('.adv-gal, .adv-tour, [data-adv-cf]').forEach(function (el) {
      if (el.__warm) return; el.__warm = true;
      if (warmIO) warmIO.observe(el); else warmImgs(el);
    });
  }

  /* ---------- reviews strip: runs by itself, can be dragged by mouse or finger ---------- */
  function initMarquee(m) {
    if (m.__mq) return; var t = m.querySelector('.adv-rv__track'); if (!t || !t.firstElementChild) return;
    m.__mq = true; m.classList.add('is-js');
    var x = 0, half = 0, v = 0, drag = false, lastX = 0, lastT = 0, hover = false, moved = 0, resumeAt = 0, seen = true, prev = 0, speed = 0;
    function measure() {
      var d = t.querySelector('.adv-rv__dup'), a = t.firstElementChild, b = d && d.firstElementChild;
      half = b ? b.getBoundingClientRect().left - a.getBoundingClientRect().left : t.scrollWidth / 2;
      var secs = parseFloat(getComputedStyle(m).getPropertyValue('--rv-speed')) || 60;
      speed = half / secs;
    }
    function wrap() { if (half > 0) { while (x <= -half) x += half; while (x > 0) x -= half; } }
    function frame(ts) {
      var dt = prev ? Math.min(64, ts - prev) : 16; prev = ts;
      if (seen && !drag) {
        if (Math.abs(v) > 0.02) { x += v * dt; v *= Math.pow(0.93, dt / 16); }
        else { v = 0; if (!reduce && !hover && ts > resumeAt) x -= speed * dt / 1000; }
      }
      wrap(); t.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      requestAnimationFrame(frame);
    }
    m.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return; measure();
      drag = true; moved = 0; v = 0; lastX = e.clientX; lastT = e.timeStamp;
      m.classList.add('is-drag');
      try { m.setPointerCapture(e.pointerId); } catch (err) {}
    });
    m.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - lastX, dt = Math.max(1, e.timeStamp - lastT);
      x += dx; moved += Math.abs(dx); v = v * 0.4 + (dx / dt) * 0.6; lastX = e.clientX; lastT = e.timeStamp;
    });
    function end() { if (!drag) return; drag = false; m.classList.remove('is-drag'); resumeAt = performance.now() + 1800; if (Math.abs(v) > 2.5) v = v > 0 ? 2.5 : -2.5; }
    m.addEventListener('pointerup', end); m.addEventListener('pointercancel', end); m.addEventListener('lostpointercapture', end);
    m.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    m.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
    m.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    m.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; }).observe(m);
    window.addEventListener('resize', measure, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('load', measure);
    measure(); requestAnimationFrame(frame);
  }
  function scanMq(scope) { (scope || document).querySelectorAll('[data-adv-marquee]').forEach(initMarquee); }

  /* ---------- urgency: countdown to a real end date (hidden once it has passed) ---------- */
  function initCount(box) {
    if (box.__ct) return; box.__ct = true;
    var end = Date.parse(box.getAttribute('data-adv-count'));
    var live = box.querySelector('.adv-ug__live'); if (!live || isNaN(end)) return;
    var q = function (k) { return box.querySelector('[data-' + k + ']'); }, d = q('d'), h = q('h'), m = q('m'), s = q('s');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { live.hidden = true; clearInterval(t); return; }
      live.hidden = false;
      d.textContent = pad(Math.floor(left / 86400)); h.textContent = pad(Math.floor(left % 86400 / 3600));
      m.textContent = pad(Math.floor(left % 3600 / 60)); s.textContent = pad(left % 60);
    }
    var t = setInterval(tick, 1000); tick();
  }
  /* ---------- sticky buy bar: after the first screen, hidden while the urgency band or the footer is visible ---------- */
  function initSticky(bar) {
    if (bar.__sb) return; bar.__sb = true;
    var sid = bar.getAttribute('data-sid');
    document.querySelectorAll('body > .adv-sb').forEach(function (o) { if (o !== bar && o.getAttribute('data-sid') === sid) o.remove(); });
    document.body.appendChild(bar);
    var band = document.querySelector('[data-adv-urg] .adv-ug'), foot = document.querySelector('footer, .advf, #shopify-section-footer, [id*="footer-group"]');
    var seen = {};
    function update() {
      var past = (window.scrollY || window.pageYOffset) > window.innerHeight * 0.9;
      var on = past && !seen.band && !seen.foot && !document.documentElement.classList.contains('advc-lock');
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      // keep the Shopify Inbox chat button above the bar while it is visible
      var rt = document.documentElement, shown = on && bar.offsetHeight > 0;
      if (shown) rt.style.setProperty('--adv-sb-h', bar.offsetHeight + 'px');
      rt.classList.toggle('adv-sb-on', shown);
    }
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (en) { en.forEach(function (e) { seen[e.target === band ? 'band' : 'foot'] = e.isIntersecting; }); update(); });
      if (band) io2.observe(band); if (foot) io2.observe(foot);
    }
    window.addEventListener('scroll', update, { passive: true }); update();
  }
  /* ---------- value-stack cards: swipe carousel with dots (mobile) ---------- */
  function initSkCar(track) {
    if (track.__sk) return; track.__sk = true;
    var dots = track.parentNode.querySelector('[data-sk-dots]'); if (!dots) return;
    var cards = [].slice.call(track.children);
    dots.innerHTML = '';
    var btns = cards.map(function (c, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + ' / ' + cards.length);
      b.addEventListener('click', function () { track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); }); dots.appendChild(b); return b; });
    function upd() { var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
      btns.forEach(function (b, i) { b.classList.toggle('is-on', i === best); }); }
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }
  function scanUrg(scope) {
    (scope || document).querySelectorAll('[data-adv-count]').forEach(initCount);
    (scope || document).querySelectorAll('[data-adv-sticky]').forEach(initSticky);
    (scope || document).querySelectorAll('[data-sk-car]').forEach(initSkCar);
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); scanCf(e.target); scanWarm(e.target); scanMq(e.target); scanUrg(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    e.target.querySelectorAll && e.target.querySelectorAll('[data-anim], [data-side-in]').forEach(function (el) { el.classList.add('is-in'); });
    if (e.target.hasAttribute && e.target.hasAttribute('data-anim')) e.target.classList.add('is-in');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); scanCf(); scanWarm(); scanMq(); scanUrg(); });
  else { scan(); scanCf(); scanWarm(); scanMq(); scanUrg(); }
})();
